import { render, staticRenderFns } from "./xiaoduixiangmulayun.vue?vue&type=template&id=22206523&scoped=true&"
import script from "./xiaoduixiangmulayun.vue?vue&type=script&lang=js&"
export * from "./xiaoduixiangmulayun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22206523",
  null
  
)

export default component.exports